import {useMemo} from 'react';
import {useQuery} from '@apollo/client';
import {GET_FILTER_STRUCTURE} from './resolvers';
import {BRANCH_FEATURE, isGqlError} from './constants';

/**
 * Fetches the filter-form metadata once and indexes it by feature.
 *
 * Called without a feature, the endpoint returns every supported structure —
 * routing contract (filterField/query/argument/inputType) plus the field
 * descriptors the editor renders from.
 */
export const useFilterStructure = () => {
  const {data, loading, error} = useQuery(GET_FILTER_STRUCTURE, {
    variables: {feature: null},
    // Reference data for the session — safe to cache.
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
  });

  const result = data?.adminGetInstrumentThemeFilterStructure;
  const unionError = isGqlError(result) ? result : null;

  const byFeature = useMemo(() => {
    if (unionError) return {};
    return (result?.data || []).reduce((accumulator, structure) => {
      const feature =
        structure.feature || BRANCH_FEATURE[structure.filterField];
      accumulator[feature] = structure;
      return accumulator;
    }, {});
  }, [result, unionError]);

  return {
    structures: byFeature,
    loading,
    error: unionError || error,
  };
};

export default useFilterStructure;
